module.exports = __webpack_public_path__ + "img/ii2-greening-the-pandemic.1bf834d5.png";